import { ScrollableContents } from '../../Common/components/ScrollableList/ScrollableContents'

/* 横スクロール型の新着コミックス */
export const ScrollableNewBookList = ({ newBooks, tabName }) => {
  const sectionTitle = '待望の新着コミックス'
  const baseUrl = '/store/new_books'
  const url = tabName === 'home' ? baseUrl : `${baseUrl}?genre_name=${tabName}`

  return <ScrollableContents contents={newBooks} tabName={tabName} sectionTitle={sectionTitle} url={url} />
}
